import { render, staticRenderFns } from "./create-classification-rule.vue?vue&type=template&id=e05de5e8&scoped=true"
import script from "./create-classification-rule.vue?vue&type=script&lang=js"
export * from "./create-classification-rule.vue?vue&type=script&lang=js"
import style0 from "./create-classification-rule.vue?vue&type=style&index=0&id=e05de5e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e05de5e8",
  null
  
)

export default component.exports